import React from "react";
import styles from "./DateInput.module.css";
import { useField, useFormikContext } from "formik";
import { DateInput as MiloDateInput, FormField } from "@justworkshr/milo-form";

interface IDateInputProps {
  name: string;
  label: string;
  message?: string;
  required?: boolean;
  className?: string;
}

const DateInput = ({ ...props }: IDateInputProps): JSX.Element => {
  const { name, label, message, required = true, className } = props;
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <div className={`${styles.container} ${className}`}>
      <FormField
        required={required}
        message={message}
        label={label}
        error={meta.touched ? meta.error : ""}
      >
        <MiloDateInput
          className={styles.dateInput}
          id={name}
          data-testid={name}
          onAccept={(val) =>
            setFieldValue(field.name, val === "_ _ /_ _ /_ _ _ _" ? "" : val)
          }
          {...field}
        />
      </FormField>
    </div>
  );
};

export default DateInput;
